// 火影忍者同人内容站 · 数据源（暂无后端连接时的展示数据）

export interface Novel {
  id: string;
  title: string;
  author: string;
  tag: string;
  summary: string;
  chapters: number;
  words: string;
  views: string;
  likes: string;
  cover: string;
  category: string;
  hot?: boolean;
}

export interface ArtWork {
  id: string;
  title: string;
  artist: string;
  type: "高清壁纸" | "同人插画";
  tag: string;
  views: string;
  cover: string;
  hot?: boolean;
}

export interface ShortStory {
  id: string;
  title: string;
  author: string;
  category: string;
  readTime: string;
  summary: string;
  cover: string;
  paragraphs: string[];
}

export interface FaqItem {
  q: string;
  a: string;
}

export interface Testimonial {
  name: string;
  role: string;
  text: string;
}

export const siteName = "影页社";
export const siteSlogan = "一张图，一段文，一场关于木叶的梦";

export const navCategories = [
  { name: "同人小说", path: "/xiaoshuo", key: "novels" },
  { name: "同人图·壁纸", path: "/tongrentu", key: "art" },
  { name: "短篇速读", path: "/duanpian", key: "short" },
];

export const novels: Novel[] = [
  {
    id: "n1",
    title: "风起之卷 · 鸣人",
    author: "一乐风",
    tag: "成长向 · 长篇",
    summary: "从吊车尾到火影，少年一路跌撞的修行手记。重新演绎第七班初遇、中忍考试与离别之夜，写尽漩涡鸣人在孤独里长成的温柔。",
    chapters: 42,
    words: "约 21 万字",
    views: "86.4万",
    likes: "3.2万",
    category: "同人小说",
    hot: true,
    cover: "https://readdy.ai/api/search-image?query=anime%20style%20cover%20art%20of%20a%20young%20blond%20ninja%20with%20orange%20jacket%20and%20whisker%20marks%20facing%20a%20warm%20sunset%20over%20a%20ninja%20village%2C%20wind%20blowing%20through%20hair%2C%20ink%20wash%20japanese%20style%2C%20dramatic%20warm%20orange%20and%20deep%20ink%20tones%2C%20high%20detail%20digital%20illustration&width=800&height=1000&seq=naruto-novel-n1&orientation=portrait",
  },
  {
    id: "n2",
    title: "晓之挽歌",
    author: "月下狸",
    tag: "悲情向 · 群像",
    summary: "以晓组织成员视角写下的暗夜群像。鼬、佩恩、小南……那些被命运选中的忍者，在黎明前的黑暗里各自走向终局。",
    chapters: 28,
    words: "约 13 万字",
    views: "52.1万",
    likes: "1.9万",
    category: "同人小说",
    cover: "https://readdy.ai/api/search-image?query=dark%20moody%20anime%20cover%20art%20of%20shadowy%20cloaked%20ninja%20figures%20with%20red%20cloud%20patterns%20standing%20in%20rain%20at%20night%2C%20crimson%20red%20clouds%2C%20ink%20wash%20japanese%20style%2C%20melancholic%20atmosphere%2C%20deep%20ink%20black%20and%20vermilion%20accents%2C%20high%20detail&width=800&height=1000&seq=naruto-novel-n2&orientation=portrait",
  },
  {
    id: "n3",
    title: "写轮眼的彼方",
    author: "雾隐画师",
    tag: "宿命向 · 双主角",
    summary: "佐助与鼬的宿命长卷。循着红色写轮眼的光，从灭族之夜到兄弟之战，再到那场迟来的和解，用更柔软的笔触重写这一对兄弟。",
    chapters: 36,
    words: "约 18 万字",
    views: "74.8万",
    likes: "2.7万",
    category: "同人小说",
    hot: true,
    cover: "https://readdy.ai/api/search-image?query=anime%20cover%20art%20of%20a%20dark%20haired%20ninja%20with%20glowing%20red%20sharingan%20eyes%20and%20blue%20lightning%20chakra%2C%20blood%20red%20moon%20background%2C%20ink%20wash%20japanese%20style%2C%20intense%20dramatic%20lighting%2C%20crimson%20and%20ink%20black%20palette%2C%20high%20detail&width=800&height=1000&seq=naruto-novel-n3&orientation=portrait",
  },
  {
    id: "n4",
    title: "波之国外的春天",
    author: "桥边芦苇",
    tag: "治愈向 · 日常",
    summary: "如果大桥没有坍塌，如果再不斩未曾离去。一段关于波之国孩子们和过路忍者的平凡四季，安静、缓慢，像河边的风。",
    chapters: 18,
    words: "约 8 万字",
    views: "31.6万",
    likes: "1.1万",
    category: "同人小说",
    cover: "https://readdy.ai/api/search-image?query=soft%20warm%20anime%20cover%20art%20of%20children%20by%20a%20countryside%20river%20with%20a%20wooden%20bridge%20and%20cherry%20blossom%20petals%20in%20spring%2C%20healing%20peaceful%20mood%2C%20ink%20wash%20japanese%20style%2C%20warm%20pastel%20orange%20and%20green%20tones%2C%20high%20detail&width=800&height=1000&seq=naruto-novel-n4&orientation=portrait",
  },
  {
    id: "n5",
    title: "木叶的四季",
    author: "卷心菜",
    tag: "群像 · 单元剧",
    summary: "以木叶村为舞台的二十四篇小故事。从春樱到冬雪，每一个平凡忍者与村民，都在四季更迭里留下自己的注脚。",
    chapters: 24,
    words: "约 11 万字",
    views: "45.3万",
    likes: "1.6万",
    category: "同人小说",
    cover: "https://readdy.ai/api/search-image?query=whimsical%20anime%20cover%20art%20of%20a%20ninja%20village%20through%20four%20seasons%20with%20cherry%20blossoms%2C%20green%20summer%2C%20red%20autumn%20leaves%20and%20snow%2C%20quaint%20wooden%20houses%2C%20ink%20wash%20japanese%20style%2C%20warm%20cozy%20palette%2C%20high%20detail&width=800&height=1000&seq=naruto-novel-n5&orientation=portrait",
  },
  {
    id: "n6",
    title: "螺旋丸与眼泪",
    author: "旗木后生",
    tag: "情感向 · 师生",
    summary: "自来也与鸣人，卡卡西与第七班。两代师徒之间的羁绊，被写进一次雨夜的修行里。原来最强的忍术，是有人愿意为你挡一场雨。",
    chapters: 15,
    words: "约 6 万字",
    views: "27.9万",
    likes: "9800",
    category: "同人小说",
    cover: "https://readdy.ai/api/search-image?query=emotional%20anime%20cover%20art%20of%20a%20white%20haired%20mentor%20ninja%20and%20a%20blond%20student%20facing%20each%20other%20in%20rain%2C%20glowing%20spiral%20chakra%20between%20their%20hands%2C%20ink%20wash%20japanese%20style%2C%20warm%20orange%20and%20blue%20rain%2C%20heartfelt%20mood%2C%20high%20detail&width=800&height=1000&seq=naruto-novel-n6&orientation=portrait",
  },
];

export const artWorks: ArtWork[] = [
  {
    id: "a1",
    title: "落日下的第七班",
    artist: "疾风绘卷",
    type: "高清壁纸",
    tag: "第七班 · 日落",
    views: "12.8万",
    hot: true,
    cover: "https://readdy.ai/api/search-image?query=wide%20anime%20wallpaper%20of%20three%20young%20ninjas%20and%20their%20teacher%20standing%20on%20a%20cliff%20watching%20a%20giant%20warm%20orange%20sunset%20over%20a%20ninja%20village%2C%20wind%20and%20leaves%2C%20cinematic%20ink%20wash%20japanese%20style%2C%20high%20detail%2C%20rich%20amber%20and%20ink%20tones&width=1600&height=900&seq=naruto-art-a1&orientation=landscape",
  },
  {
    id: "a2",
    title: "千鸟与螺旋丸",
    artist: "雷电分毫",
    type: "同人插画",
    tag: "战斗 · 羁绊",
    views: "9.4万",
    hot: true,
    cover: "https://readdy.ai/api/search-image?query=dramatic%20anime%20illustration%20of%20two%20rival%20ninjas%20charging%20toward%20each%20other%20one%20with%20blue%20lightning%20chakra%20and%20one%20with%20an%20orange%20spiral%20sphere%2C%20energy%20clash%2C%20ink%20wash%20japanese%20style%2C%20electric%20blue%20and%20warm%20orange%20contrast%2C%20high%20detail&width=1000&height=1250&seq=naruto-art-a2&orientation=portrait",
  },
  {
    id: "a3",
    title: "木叶村全景",
    artist: "树影摇",
    type: "高清壁纸",
    tag: "风景 · 全景",
    views: "15.3万",
    cover: "https://readdy.ai/api/search-image?query=breathtaking%20anime%20landscape%20wallpaper%20of%20a%20ninja%20village%20with%20four%20carved%20stone%20faces%20on%20a%20mountain%2C%20sunset%20golden%20light%2C%20houses%20and%20trees%2C%20ink%20wash%20japanese%20style%2C%20warm%20amber%20and%20soft%20shadow%2C%20high%20detail&width=1600&height=900&seq=naruto-art-a3&orientation=landscape",
  },
  {
    id: "a4",
    title: "晓月",
    artist: "绯云",
    type: "同人插画",
    tag: "晓组织 · 夜景",
    views: "8.2万",
    cover: "https://readdy.ai/api/search-image?query=atmospheric%20anime%20illustration%20of%20a%20lone%20cloaked%20ninja%20with%20red%20cloud%20pattern%20under%20a%20huge%20blood%20red%20moon%2C%20night%20sky%2C%20melancholic%20mood%2C%20ink%20wash%20japanese%20style%2C%20crimson%20and%20deep%20ink%20tones%2C%20high%20detail&width=1000&height=1250&seq=naruto-art-a4&orientation=portrait",
  },
  {
    id: "a5",
    title: "卡卡西的雨天",
    artist: "夕立",
    type: "高清壁纸",
    tag: "人物 · 雨天",
    views: "10.7万",
    cover: "https://readdy.ai/api/search-image?query=melancholic%20anime%20wallpaper%20of%20a%20white%20haired%20ninja%20with%20a%20mask%20sitting%20by%20a%20window%20watching%20heavy%20rain%2C%20moody%20blue%20and%20warm%20lamp%20light%2C%20ink%20wash%20japanese%20style%2C%20quiet%20emotional%20atmosphere%2C%20high%20detail&width=1600&height=900&seq=naruto-art-a5&orientation=landscape",
  },
  {
    id: "a6",
    title: "初代火影",
    artist: "千手叶",
    type: "同人插画",
    tag: "历史 · 木叶",
    views: "7.6万",
    cover: "https://readdy.ai/api/search-image?query=majestic%20anime%20illustration%20of%20a%20legendary%20founder%20ninja%20with%20long%20dark%20hair%20standing%20amid%20giant%20wooden%20trees%20and%20vines%2C%20powerful%20and%20serene%2C%20ink%20wash%20japanese%20style%2C%20deep%20green%20and%20ink%20tones%20with%20warm%20light%2C%20high%20detail&width=1000&height=1250&seq=naruto-art-a6&orientation=portrait",
  },
  {
    id: "a7",
    title: "鸣人与佐助",
    artist: "双子星",
    type: "高清壁纸",
    tag: "羁绊 · 双人",
    views: "13.1万",
    hot: true,
    cover: "https://readdy.ai/api/search-image?query=powerful%20anime%20wallpaper%20of%20two%20rival%20ninjas%20back%20to%20back%20in%20a%20stormy%20battlefield%2C%20one%20with%20orange%20aura%20and%20one%20with%20purple%20lightning%2C%20dramatic%20warm%20lighting%2C%20ink%20wash%20japanese%20style%2C%20high%20detail&width=1600&height=900&seq=naruto-art-a7&orientation=landscape",
  },
  {
    id: "a8",
    title: "秋日红叶",
    artist: "枫未眠",
    type: "同人插画",
    tag: "日常 · 治愈",
    views: "6.9万",
    cover: "https://readdy.ai/api/search-image?query=cozy%20anime%20illustration%20of%20a%20young%20ninja%20girl%20with%20long%20pink%20hair%20walking%20through%20autumn%20red%20maple%20trees%20in%20a%20peaceful%20village%20street%2C%20golden%20afternoon%20light%2C%20ink%20wash%20japanese%20style%2C%20warm%20red%20and%20gold%20tones%2C%20high%20detail&width=1000&height=1250&seq=naruto-art-a8&orientation=portrait",
  },
];

export const shortStories: ShortStory[] = [
  {
    id: "s1",
    title: "一碗拉面的温度",
    author: "一乐风",
    category: "治愈 · 日常",
    readTime: "6 分钟",
    summary: "夜深了，一乐拉面店还亮着灯。那碗加了叉烧的味增拉面，藏着木叶最暖的秘密。",
    cover: "https://readdy.ai/api/search-image?query=cozy%20anime%20illustration%20of%20a%20small%20warm%20ramen%20shop%20at%20night%20with%20steam%20rising%20from%20a%20bowl%20of%20ramen%20and%20soft%20lantern%20light%2C%20peaceful%20evening%2C%20ink%20wash%20japanese%20style%2C%20warm%20amber%20tones%2C%20high%20detail&width=1200&height=800&seq=naruto-story-s1&orientation=landscape",
    paragraphs: [
      "木叶的夜，总是从灯火一盏盏熄灭开始。只有一乐拉面店门口的那盏灯笼，像颗不肯入睡的萤火，固执地亮到很晚。",
      "手打面在沸水里翻滚，汤底是熬了一整天的豚骨白汤。大叔用那双长年揉面的手，把面团拉成细长的银线，仿佛把一整天的疲惫都揉了进去。",
      "鸣人总在深夜造访。他点一碗味增拉面加叉烧，坐在角落的位置，把帽子压得很低。大叔从不多问，只默默在碗里多放两片叉烧。",
      "“慢点吃，小心烫。”大叔把面端上来，汤面氤氲的白雾模糊了少年的眼睛。那碗面的温度，透过粗瓷碗壁，一直暖到心里。",
      "原来所谓的家，不过是深夜有人为你留一盏灯，温一碗面。木叶的忍者守望着村子，而这一碗拉面，守望着每一个疲惫的归人。",
    ],
  },
  {
    id: "s2",
    title: "河边的那一天",
    author: "桥边芦苇",
    category: "亲情 · 治愈",
    readTime: "5 分钟",
    summary: "盛夏的河边，蝉鸣不止。有些话，是在那个午后才终于说出口的。",
    cover: "https://readdy.ai/api/search-image?query=gentle%20anime%20illustration%20of%20a%20father%20and%20son%20sitting%20on%20a%20sunny%20riverbank%20in%20summer%2C%20cicadas%20and%20sparkling%20water%2C%20warm%20golden%20light%2C%20ink%20wash%20japanese%20style%2C%20tender%20peaceful%20mood%2C%20high%20detail&width=1200&height=800&seq=naruto-story-s2&orientation=landscape",
    paragraphs: [
      "夏天的河边，蝉鸣得像要把天都叫破。波之国的河水清可见底，映着两岸新绿的芦苇。",
      "少年和男人并排坐在石头上，两双光脚在河水里晃着。谁也没有先开口，只有河水在脚踝处打着漩涡。",
      "“你……真的要走吗？”少年终于问出声，声音被蝉鸣盖住了大半。男人却听见了，他望着远山，沉默了很久。",
      "“嗯。但等我回来，给你带一包最好的苦无，还有你最爱吃的甜丸子。”男人咧开嘴笑了，眼角的疤也跟着弯起来。",
      "那天他们没说太多话。可很多年后，少年守着这座桥，守着这条河，才终于明白：有些诺言，比最坚固的桥还要牢。",
    ],
  },
  {
    id: "s3",
    title: "迟到之人的信",
    author: "旗木后生",
    category: "羁绊 · 情感",
    readTime: "7 分钟",
    summary: "老师总说忍者从不迟到，可他等了半生，才等到那封迟来的信。",
    cover: "https://readdy.ai/api/search-image?query=emotional%20anime%20illustration%20of%20an%20old%20letter%20with%20wax%20seal%20lying%20on%20a%20wooden%20desk%20by%20a%20window%20with%20soft%20morning%20light%20and%20tea%2C%20nostalgic%20mood%2C%20ink%20wash%20japanese%20style%2C%20warm%20amber%20tones%2C%20high%20detail&width=1200&height=800&seq=naruto-story-s3&orientation=landscape",
    paragraphs: [
      "旗木家的窗台上，常年放着一封信。信纸已经泛黄，边缘起了毛，却始终没有被打开。",
      "写信的人是位故去的师长，他说好了要亲口把一些话说完，却没能等到约定的那天。",
      "年轻一代的忍者总说，老师一生最重守时。可只有他身边的人知道，老师这辈子，最怕的就是迟到的人。",
      "“忍者从不迟到。”这句话被刻在忍者的准则里。但有些告别，却让人无论如何也赶不上。",
      "那封信终于在一个下雨的傍晚被拆开。纸上是熟悉的字迹，只写着一行：对不起，我迟到了。然后是一句，我为你骄傲。窗外的雨声忽然就模糊了视线。",
    ],
  },
  {
    id: "s4",
    title: "火影岩下的仰望",
    author: "月下狸",
    category: "梦想 · 传承",
    readTime: "5 分钟",
    summary: "火影岩上刻着历代火影的脸，而每一个仰望它的人，心里都刻着一个自己的名字。",
    cover: "https://readdy.ai/api/search-image?query=inspiring%20anime%20illustration%20of%20four%20giant%20carved%20stone%20faces%20of%20ninja%20leaders%20on%20a%20mountain%20at%20dawn%2C%20a%20small%20boy%20standing%20below%20looking%20up%2C%20golden%20morning%20light%2C%20ink%20wash%20japanese%20style%2C%20warm%20hopeful%20tones%2C%20high%20detail&width=1200&height=800&seq=naruto-story-s4&orientation=landscape",
    paragraphs: [
      "木叶村外那座山崖上，刻着历代火影的面孔。风吹日晒，石像依旧沉默地望着村子，像守护神一样。",
      "孩子们放学后总爱爬到岩下的空地，仰着脖子数火影们的名字。谁刻得多，谁就赢。",
      "有个吊车尾的少年，总在人群散尽后独自留下。他对着岩壁小声说：“总有一天，我的脸也会刻上去。”",
      "风把他的声音吹散在山谷里，没有人听见。可火影岩记得，记得每一个仰望它的孩子眼里的光。",
      "很多年后，当新的面孔终于被刻上岩壁，人们才恍然：原来梦想这东西，不怕大声说出来，就怕你不肯仰望。",
    ],
  },
];

export const faqs: FaqItem[] = [
  {
    q: "影页社是《火影忍者》官方网站吗？",
    a: "不是。影页社是一个由同人爱好者自发创作与整理的粉丝内容站点，所收录的小说、插画与壁纸均为同人作品，与官方作品无授权关系，也不代表官方立场。所有内容仅供同好交流与欣赏。",
  },
  {
    q: "高清壁纸与插画可以下载使用吗？",
    a: "可以。本站提供的高清火影忍者同人壁纸与插画均标注了作者，供个人欣赏、设备壁纸等非商业用途使用。若希望转载或商用，请务必先联系原作者取得授权，并注明出处。",
  },
  {
    q: "我自己也画了火影同人图，可以投稿吗？",
    a: "非常欢迎。你可以在“关于我们”页面找到投稿邮箱，将作品（含作者署名、标题与简介）发给我们，我们会在审核通过后发布到对应栏目，并为你保留署名。",
  },
  {
    q: "同人小说多久更新一次？",
    a: "热门连载小说一般每周更新 1—2 章，短篇速读栏目则每日精选推送 1—2 篇新作。你可以订阅页脚的邮件通知，第一时间收到新内容更新。",
  },
  {
    q: "短篇速读的内容可以免费阅读吗？",
    a: "可以，本站所有短篇速读与同人小说均对读者免费开放阅读，无需注册登录。我们希望通过开放的方式，让更多同好能轻松看到优质内容。",
  },
  {
    q: "影页社会推出实体周边或线下活动吗？",
    a: "目前影页社以线上图文内容为主，暂不涉及实体周边与线下活动。未来如有规划，我们会通过官网公告与邮件通知第一时间同步给大家。",
  },
];

export const testimonials: Testimonial[] = [
  {
    name: "阿蓝",
    role: "同人小说读者",
    text: "在这里把《风起之卷》连夜看完，久违地被同人故事触动。文字细腻，更新又稳定，是追更党的宝藏站点。",
  },
  {
    name: "青栀",
    role: "壁纸收藏者",
    text: "壁纸质量太高了，落日夜空那几张我全部收藏了。画风统一、清晰度也够，做手机和电脑壁纸都很好看。",
  },
  {
    name: "南烛",
    role: "业余画手",
    text: "作为画手，看到自己的同人图能被更多人欣赏很开心。投稿流程简单，编辑还帮我改了标题，很贴心。",
  },
  {
    name: "木叶打工人",
    role: "短篇速读用户",
    text: "每天午休看一篇短篇刚刚好。《一碗拉面的温度》看得我眼眶发热，这波治愈我吃得很满意。",
  },
];